export const MoveToTop = () => (
    <div>
        <img src="/scrol-button.png" alt="Scroll Button"
            style={{
                position: 'fixed',
                bottom: '5%',
                right: '5%',
                zIndex: 1000,
                width: '5%',
                minWidth: '30px',
                maxWidth: '60px',
                cursor: 'pointer'
            }}
             onClick={() => {
                 window.scrollTo({
                     top: 0,
                     behavior: 'smooth'
                 });
             }}
        />
    </div>
);